export const pcgSettingsDemo = {"mode":"Demo","apiBaseUrl":"https://localhost:5001","rollbarPostClientToken":"0953d8b0feed449a882d35b4a04610c7"};
